// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100%;
    background-color: #8a8a8a;
    font-family: "Inter";
}

.login-container {
    background-color: white;
    border-radius: 15px;
    padding: 30px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    width: 400px;
    height: 700px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
}

h1 {
    color: #afaeae;
    font-size: 50px;
}

.logo {
    width: 200px;
}

.input-field {
    width: calc(100% - 20px);
    padding: 10px;
    margin: 10px 0;
    border: none;
    border-bottom: 1px solid black;
    outline: none;
    font-size: 15px;
}

.login-button {
    width: calc(100% - 100px);
    padding: 10px;
    margin: 20px 0;
    border: none;
    border-radius: 10px;
    background-color: #008cdd;
    color: white;
    font-size: 16px;
    cursor: pointer;
    margin-top: 50px;
}

.login-button:hover {
    background-color: #007bb5;
}

.form-footer {
    height: 5%;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    a {
        color: #0075ff;
        cursor: pointer;
        text-decoration: none;
    }
}

`, "",{"version":3,"sources":["webpack://./src/pages/auth/reset-password/reset-password.page.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,uCAAuC;IACvC,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,aAAa;IACb,cAAc;IACd,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;;IAEnB;QACI,cAAc;QACd,eAAe;QACf,qBAAqB;IACzB;AACJ","sourcesContent":[".login-page {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    width: 100%;\n    background-color: #8a8a8a;\n    font-family: \"Inter\";\n}\n\n.login-container {\n    background-color: white;\n    border-radius: 15px;\n    padding: 30px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n    width: 400px;\n    height: 700px;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    align-items: center;\n}\n\nh1 {\n    color: #afaeae;\n    font-size: 50px;\n}\n\n.logo {\n    width: 200px;\n}\n\n.input-field {\n    width: calc(100% - 20px);\n    padding: 10px;\n    margin: 10px 0;\n    border: none;\n    border-bottom: 1px solid black;\n    outline: none;\n    font-size: 15px;\n}\n\n.login-button {\n    width: calc(100% - 100px);\n    padding: 10px;\n    margin: 20px 0;\n    border: none;\n    border-radius: 10px;\n    background-color: #008cdd;\n    color: white;\n    font-size: 16px;\n    cursor: pointer;\n    margin-top: 50px;\n}\n\n.login-button:hover {\n    background-color: #007bb5;\n}\n\n.form-footer {\n    height: 5%;\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    a {\n        color: #0075ff;\n        cursor: pointer;\n        text-decoration: none;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
